import { createTheme } from '@mui/material'

export const muiTheme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#3353B2',
    },
    secondary: {
      main: '#959393',
    },
    error: {
      main: '#D73F3F',
    },
    warning: {
      main: '#FBCB1A',
    },
    success: {
      main: '#9CCC2C',
    },
  },
  shape: {
    borderRadius: 8,
  },
})
